/*
  Love'nSpa - instrumentation du parcours de reservation

  Cadre RGPD, exemption de consentement CNIL pour la mesure d'audience :
  1. Finalite limitee a la mesure d'audience du site. Aucun recoupement avec un
     autre traitement, aucune transmission a un tiers.
  2. Identifiant de visite non persistant, stocke en sessionStorage. Pas de
     cookie, pas de localStorage, aucune reconstitution du parcours entre visites.
  3. Aucune adresse IP stockee, meme tronquee, et aucun user agent brut.

  Le widget de reservation Bookingmood est charge dans une iframe cross-origin.
  Le JavaScript de la page ne peut donc pas lire ce qui se passe a l'interieur.

  ETAT DU FUNNEL : SCENARIO B (mode degrade), verifie sur la fiche pilote.
  Evenements reellement collectes : fiche_view, widget_visible, widget_interact,
  contact_reveal, contact_direct, fiche_exit.
  Evenements INACTIFS : date_selected, no_availability, checkout_start.
  Verification du 2 septembre 2026 sur https://lovenspa.fr/products/jacuzzi-secret-91 :
   - Bookingmood n'emet qu'un seul message, {context: 'iframe.resize', height};
   - la page parente ne contient AUCUN lien vers bookingmood.com. Le bouton
     Reserver maintenant est a l'interieur de l'iframe cross-origin : son clic
     ne remonte jamais au document parent, quelle que soit la phase de capture.
  Consequence assumee : le funnel s'arrete a widget_interact.
*/

(function () {
  'use strict';

  try {
    var config = window.LNS_FUNNEL || {};
    if (!config.endpoint) {
      return; // Rien a faire si le snippet Liquid n'a pas ete pose.
    }

    // ----------------------------------------------------------------
    // 1. Identifiant de visite
    // ----------------------------------------------------------------
    // Genere une chaine aleatoire, conservee le temps de l'onglet uniquement.
    function getSessionId() {
      var cle = 'lns_funnel_session';
      var valeur = null;
      try {
        valeur = window.sessionStorage.getItem(cle);
      } catch (e) {
        valeur = null;
      }
      if (!valeur) {
        valeur = 'sess_' + Math.random().toString(36).slice(2) + Date.now().toString(36);
        try {
          window.sessionStorage.setItem(cle, valeur);
        } catch (e) {
          // Navigation privee ou stockage bloque : on garde la valeur en memoire.
        }
      }
      return valeur;
    }

    var sessionId = getSessionId();

    // ----------------------------------------------------------------
    // 2. Contexte de la visite, sans donnee personnelle
    // ----------------------------------------------------------------
    function detecterAppareil() {
      var largeur = window.innerWidth || document.documentElement.clientWidth || 0;
      if (largeur < 768) return 'mobile';
      if (largeur < 1024) return 'tablet';
      return 'desktop';
    }

    function domaineDe(url) {
      try {
        return new URL(url, window.location.href).hostname;
      } catch (e) {
        return null;
      }
    }

    var parametres = new URLSearchParams(window.location.search);

    var contexte = {
      session_id: sessionId,
      shopify_product_id: config.productId ? String(config.productId) : null,
      handle: config.handle || null,
      page_url: window.location.origin + window.location.pathname,
      referrer_host: document.referrer ? domaineDe(document.referrer) : null,
      device: detecterAppareil(),
      utm_source: parametres.get('utm_source'),
      utm_medium: parametres.get('utm_medium'),
      utm_campaign: parametres.get('utm_campaign')
    };

    // ----------------------------------------------------------------
    // 3. File d'envoi, par paquets de 5 secondes
    // ----------------------------------------------------------------
    var file = [];
    var minuteur = null;
    // Evenements a envoyer une seule fois par visite. La cle de deduplication
    // est le couple type + source (payload.source), et non le type seul :
    // widget_interact peut arriver par 'resize' puis par 'focus_iframe' dans
    // la meme visite. Dedupliquer sur le type seul ferait toujours gagner
    // 'resize' (il tire au chargement) et rendrait impossible l'arbitrage sur
    // la frequence relative des deux sources (requete de controle numero 1).
    var dejaEnvoyes = {};

    function corpsRequete(evenements) {
      var corps = {};
      for (var cle in contexte) {
        if (Object.prototype.hasOwnProperty.call(contexte, cle)) {
          corps[cle] = contexte[cle];
        }
      }
      corps.events = evenements;
      return JSON.stringify(corps);
    }

    function vider(utiliserBeacon) {
      if (!file.length) return;
      var lot = file.splice(0, file.length);
      var corps = corpsRequete(lot);

      // sendBeacon est obligatoire au dechargement de la page : un fetch
      // classique est annule des que la page part.
      if (utiliserBeacon && navigator.sendBeacon) {
        try {
          navigator.sendBeacon(config.endpoint, new Blob([corps], { type: 'application/json' }));
          return;
        } catch (e) {
          // On retombe sur fetch ci dessous.
        }
      }

      try {
        fetch(config.endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: corps,
          keepalive: true,
          mode: 'cors'
        }).catch(function () {});
      } catch (e) {
        // Aucune erreur ne doit remonter a la page.
      }
    }

    function programmerEnvoi() {
      if (minuteur) return;
      minuteur = window.setTimeout(function () {
        minuteur = null;
        vider(false);
      }, 5000);
    }

    // immediat : vrai pour fiche_exit (et checkout_start si un jour actif).
    function envoyer(type, payload, options) {
      options = options || {};
      payload = payload || {};
      if (options.uneSeuleFois) {
        var cle = type + ':' + (payload.source || '');
        if (dejaEnvoyes[cle]) return;
        dejaEnvoyes[cle] = true;
      }
      file.push({
        event_type: type,
        occurred_at: new Date().toISOString(),
        payload: payload || {}
      });
      if (options.immediat) {
        if (minuteur) {
          window.clearTimeout(minuteur);
          minuteur = null;
        }
        vider(options.beacon === true);
      } else {
        programmerEnvoi();
      }
    }

    // ----------------------------------------------------------------
    // 4. Arrivee sur la fiche
    // ----------------------------------------------------------------
    var debutVisite = Date.now();
    envoyer('fiche_view', {}, { uneSeuleFois: true });

    // ----------------------------------------------------------------
    // 5. Le calendrier entre dans le champ de vision
    // ----------------------------------------------------------------
    // On observe l'iframe Bookingmood elle-meme, avec un threshold de 0.
    // Un seul pixel visible pendant 1 seconde suffit a conclure que le visiteur
    // a atteint le calendrier. Un seuil de 50 pour cent serait inatteignable :
    // la sonde pilote releve une hauteur de widget d'environ 1 410 px, ce qui
    // depasse largement un viewport mobile (650-800 px). Observer le parent
    // aggraverait le probleme car il est au moins aussi haut que l'iframe.
    // Le delai d'une seconde ecarte les scrolls rapides qui traversent la zone.
    function trouverIframeWidget() {
      var iframes = document.querySelectorAll('iframe');
      for (var i = 0; i < iframes.length; i++) {
        var src = iframes[i].getAttribute('src') || '';
        if (src.indexOf('bookingmood.com') !== -1) {
          return iframes[i];
        }
      }
      return null;
    }

    var iframeWidget = trouverIframeWidget();
    var attenteVisibilite = null;

    function observerVisibilite() {
      if (!iframeWidget || !('IntersectionObserver' in window)) return;

      var observateur = new IntersectionObserver(function (entrees) {
        for (var i = 0; i < entrees.length; i++) {
          if (entrees[i].isIntersecting) {
            if (!attenteVisibilite) {
              attenteVisibilite = window.setTimeout(function () {
                envoyer('widget_visible', {}, { uneSeuleFois: true });
                observateur.disconnect();
              }, 1000);
            }
          } else if (attenteVisibilite) {
            window.clearTimeout(attenteVisibilite);
            attenteVisibilite = null;
          }
        }
      }, { threshold: 0 });

      observateur.observe(iframeWidget);
    }

    // L'iframe peut etre injectee apres le chargement : on retente un moment.
    if (iframeWidget) {
      observerVisibilite();
    } else {
      var essais = 0;
      var recherche = window.setInterval(function () {
        essais = essais + 1;
        iframeWidget = trouverIframeWidget();
        if (iframeWidget) {
          window.clearInterval(recherche);
          observerVisibilite();
        } else if (essais > 20) {
          window.clearInterval(recherche);
        }
      }, 500);
    }

    // ----------------------------------------------------------------
    // 6. Interaction avec le calendrier
    // ----------------------------------------------------------------
    // Le contenu de l'iframe est cross-origin : impossible de savoir qu'un
    // visiteur a clique sur une date. La seule methode fiable consiste a
    // observer que la fenetre parente perd le focus (window.blur) alors que
    // l'element actif de la page est justement l'iframe du widget. Cela
    // signifie que le clic a ete capte par l'iframe. C'est une approximation
    // assumee : elle detecte le fait d'avoir touche le calendrier, pas ce qui
    // y a ete fait.
    // La deduplication se fait par couple type + source (payload.source), et
    // non par type seul : widget_interact peut arriver par 'resize' puis par
    // 'focus_iframe' dans la meme visite. Les deux sources doivent pouvoir
    // coexister pour permettre l'arbitrage sur leur frequence relative.
    // Le payload porte toujours source: 'focus_iframe' ou 'resize' afin de
    // pouvoir arbitrer plus tard sur des chiffres (voir requete de controle
    // en fin de fichier).
    window.addEventListener('blur', function () {
      window.setTimeout(function () {
        var actif = document.activeElement;
        if (actif && actif.tagName === 'IFRAME') {
          var src = actif.getAttribute('src') || '';
          if (src.indexOf('bookingmood.com') !== -1) {
            envoyer('widget_interact', { source: 'focus_iframe' }, { uneSeuleFois: true });
          }
        }
      }, 0);
    });

    // ----------------------------------------------------------------
    // 7. Messages envoyes par le widget Bookingmood
    // ----------------------------------------------------------------
    // Aujourd'hui le widget n'emet qu'un message de redimensionnement
    // (context iframe.resize). Un changement de hauteur significatif indique
    // que le contenu du calendrier s'est deploye, donc que le visiteur a agi :
    // c'est un signal secondaire d'interaction, heuristique et a recalibrer.
    // Le payload conserve aussi le delta de hauteur pour affiner le seuil.
    // Ce bloc est aussi le point de branchement pret a recevoir de vrais
    // evenements de calendrier si Bookingmood venait a les exposer.
    var derniereHauteur = null;

    window.addEventListener('message', function (evenement) {
      var origine = evenement.origin;
      if (origine !== 'https://bookingmood.com' && origine !== 'https://www.bookingmood.com') {
        return;
      }

      var donnees = evenement.data;
      if (typeof donnees === 'string') {
        try {
          donnees = JSON.parse(donnees);
        } catch (e) {
          return;
        }
      }
      if (!donnees || typeof donnees !== 'object') return;

      var contexteMessage = donnees.context || donnees.type || '';

      if (contexteMessage === 'iframe.resize') {
        var hauteur = Number(donnees.height || 0);
        if (derniereHauteur !== null && Math.abs(hauteur - derniereHauteur) > 80) {
          envoyer(
            'widget_interact',
            { source: 'resize', delta_px: Math.round(Math.abs(hauteur - derniereHauteur)) },
            { uneSeuleFois: true }
          );
        }
        derniereHauteur = hauteur;
        return;
      }

      // ---- Point de branchement SCENARIO A : INACTIF a ce jour ----
      // Bookingmood n'emet aucun de ces trois messages (verifie par sonde).
      // Le code est conserve tel quel pour s'activer sans redeploiement le
      // jour ou Bookingmood exposerait ces evenements. Tant que ce n'est pas
      // le cas, date_selected, no_availability et checkout_start restent a zero.
      if (contexteMessage === 'booking.date_selected') {
        envoyer('date_selected', { dates: donnees.dates || null });
      } else if (contexteMessage === 'booking.no_availability') {
        envoyer('no_availability', {});
      } else if (contexteMessage === 'booking.checkout_start') {
        envoyer('checkout_start', {}, { immediat: true });
      }
      // Tout autre message est ignore sans erreur.
    });

    // ----------------------------------------------------------------
    // 8. Contact direct et sorties de page
    // ----------------------------------------------------------------
    // Objectif : mesurer une FUITE hors commission, c'est a dire un visiteur
    // qui quitte le parcours pour joindre l'hebergeur en direct.
    // Contre exemple a exclure absolument : le partage social ou par mail,
    // qui est au contraire le comportement le plus engage de la page. La fiche
    // produit contient un lien mailto sans destinataire (partage), ainsi que
    // des liens vers wa.me, facebook, instagram, tiktok, judge.me et
    // openstreetmap. Les compter comme fuite inverserait completement le signal.

    // Domaines neutres : trafic sortant normal d'une fiche produit, jamais
    // une fuite de commission. Compare sur le domaine et ses sous domaines.
    //
    // INTERDICTION ABSOLUE : ne jamais ajouter ici une plateforme de
    // reservation concurrente. Nommement, et sans que la liste soit limitative :
    //   airbnb.fr, airbnb.com, booking.com, abritel.fr, gitesdefrance.com,
    //   leboncoin.fr, expedia.fr
    // Un clic vers l'une d'elles est par definition une fuite de commission :
    // c'est exactement ce que contact_direct doit capter. Le metafield
    // accentuate.url porte d'ailleurs une annonce Airbnb sur certaines fiches
    // (non rendue dans le HTML public a ce jour, mais elle peut l'etre demain),
    // de meme que accentuate.telephone et accentuate.email. Voir du trafic
    // sortant vers ces domaines n'est pas un faux positif a blanchir, c'est
    // le signal.
    var DOMAINES_NEUTRES = [
      'facebook.com',
      'instagram.com',
      'tiktok.com',
      'wa.me',
      'whatsapp.com',
      'x.com',
      'twitter.com',
      'pinterest.com',
      'pinterest.fr',
      'linkedin.com',
      'youtube.com',
      'openstreetmap.org',
      'judge.me',
      'shopify.com',
      'shopifycdn.com',
      'unpkg.com',
      'leafletjs.com',
      'google.com',
      'gstatic.com'
    ];

    function estNeutre(domaine) {
      if (!domaine) return true;
      var d = domaine.toLowerCase();
      for (var i = 0; i < DOMAINES_NEUTRES.length; i++) {
        var n = DOMAINES_NEUTRES[i];
        if (d === n || d.slice(-(n.length + 1)) === '.' + n) return true;
      }
      // pinterest.* et autres declinaisons pays.
      if (d === 'pinterest' || d.indexOf('pinterest.') === 0 || d.indexOf('.pinterest.') !== -1) return true;
      return false;
    }

    // Un mailto de partage n'a pas de destinataire, ou porte subject / body.
    function estMailtoDePartage(href) {
      var reste = href.slice('mailto:'.length);
      var separateur = reste.indexOf('?');
      var destinataire = (separateur === -1 ? reste : reste.slice(0, separateur)).trim();
      if (!destinataire) return true;
      var query = separateur === -1 ? '' : reste.slice(separateur + 1).toLowerCase();
      if (query.indexOf('subject=') !== -1 || query.indexOf('body=') !== -1) return true;
      return false;
    }

    // Delegation d'evenement sur document : un seul ecouteur pour tous les liens.
    document.addEventListener('click', function (evenement) {
      var element = evenement.target;
      while (element && element.tagName !== 'A') {
        element = element.parentElement;
      }
      if (!element) return;

      var href = element.getAttribute('href') || '';
      if (!href) return;

      if (href.indexOf('tel:') === 0) {
        // Un tel: n'a de sens que pour appeler quelqu'un : toujours une fuite.
        if (href.slice(4).trim()) {
          envoyer('contact_direct', { canal: 'telephone', domaine: null });
        }
        return;
      }

      if (href.indexOf('mailto:') === 0) {
        if (estMailtoDePartage(href)) return; // Partage, pas contact.
        envoyer('contact_direct', { canal: 'email', domaine: null });
        return;
      }

      var domaine = domaineDe(element.href);
      if (!domaine || domaine === window.location.hostname) return;

      // ---- Point de branchement SCENARIO A : INACTIF a ce jour ----
      // Verifie le 2 septembre 2026 sur la fiche pilote : la page parente ne
      // contient aucun lien vers bookingmood.com. Le bouton Reserver maintenant
      // vit dans l'iframe cross-origin, son clic ne remonte jamais au document
      // parent. Cette branche ne se declenchera que si le theme pose un jour un
      // lien sortant direct vers Bookingmood.
      if (domaine.indexOf('bookingmood.com') !== -1) {
        envoyer('checkout_start', { domaine: domaine }, { immediat: true });
        return;
      }

      // Reseaux sociaux, cartographie, avis, CDN : trafic normal, pas une fuite.
      if (estNeutre(domaine)) return;

      // Reste : domaine externe non identifie, potentielle fuite hors commission.
      // Le domaine est toujours consigne pour recalibrer la liste blanche.
      envoyer('contact_direct', { canal: 'lien_sortant', domaine: domaine });
    }, true);

    // ----------------------------------------------------------------
    // 8bis. Revelation des coordonnees hebergeur
    // ----------------------------------------------------------------
    // Le theme n'expose JAMAIS le telephone ni l'URL du site en clair : le
    // snippet loven-contact-reveal.liquid encode la valeur en base64 inverse
    // cote serveur et rend un simple bouton :
    //   <button data-loven-reveal="phone|url" data-loven-payload="...">
    // C'est un dispositif anti-scraping. La delegation de la section 8, qui
    // cherche a[href^="tel:"] et les liens sortants, ne capte donc rien au
    // chargement de la page : il n'y a aucun lien, seulement des boutons.
    //
    // On ecoute ici les boutons eux-memes. C'est un signal d'intention plus
    // net qu'un clic sur un lien : personne ne clique sur "Voir le numero"
    // par accident, alors qu'un tel: peut etre un clic parasite sur mobile.
    //
    // Funnel de fuite a deux etages pour le telephone :
    //   contact_reveal canal telephone = je veux le numero ;
    //   contact_direct canal telephone = j'appelle vraiment. Capte par la
    //   section 8 sans rien ajouter, car loven-contact-reveal.js remplace le
    //   bouton par un vrai <a href="tel:...">.
    // Pour le site il n'y a qu'un etage : loven-contact-reveal.js fait un
    // window.open() sans jamais ecrire l'URL dans le DOM, donc aucun clic sur
    // un lien n'existera jamais. contact_direct ne se produira pas dans ce cas.
    //
    // RGPD : on n'envoie QUE le canal, jamais la valeur. Le payload du bouton
    // est decodable, mais le decoder ici reviendrait a transmettre le numero
    // ou l'URL de l'hebergeur, qui sont des donnees personnelles. L'identite
    // de l'hebergement est deja portee cote serveur par hebergement_id.
    //
    // Ecouteur independant de loven-contact-reveal.js : les deux delegations
    // coexistent sans se gener. Ne jamais ajouter l'appel de tracking dans
    // loven-contact-reveal.js, cela couplerait l'anti-scraping a la mesure
    // d'audience et la prochaine mise a jour de l'un casserait l'autre.
    document.addEventListener('click', function (evenement) {
      var bouton = evenement.target;
      while (bouton && !(bouton.getAttribute && bouton.getAttribute('data-loven-reveal'))) {
        bouton = bouton.parentElement;
      }
      if (!bouton) return;

      var kind = bouton.getAttribute('data-loven-reveal');
      var canal = kind === 'phone' ? 'telephone' : (kind === 'url' ? 'site' : null);
      if (!canal) return;

      envoyer('contact_reveal', { canal: canal }, { uneSeuleFois: true });
    }, true);

    // ----------------------------------------------------------------
    // 9. Depart de la page
    // ----------------------------------------------------------------
    var scrollMaximum = 0;

    function mesurerScroll() {
      var hauteurDocument = Math.max(
        document.body ? document.body.scrollHeight : 0,
        document.documentElement ? document.documentElement.scrollHeight : 0
      );
      if (hauteurDocument <= 0) return;
      var position = (window.scrollY || window.pageYOffset || 0) + window.innerHeight;
      var pourcentage = Math.round((position / hauteurDocument) * 100);
      if (pourcentage > scrollMaximum) {
        scrollMaximum = Math.min(pourcentage, 100);
      }
    }

    window.addEventListener('scroll', mesurerScroll, { passive: true });
    mesurerScroll();

    var sortieEnvoyee = false;

    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState !== 'hidden' || sortieEnvoyee) return;
      sortieEnvoyee = true;
      envoyer(
        'fiche_exit',
        {
          duree_s: Math.round((Date.now() - debutVisite) / 1000),
          scroll_pct: scrollMaximum
        },
        { immediat: true, beacon: true }
      );
    });
  } catch (erreur) {
    // Le tracker ne doit jamais casser la page ni afficher d'erreur.
  }
})();

/*
  ----------------------------------------------------------------------
  REQUETES DE CONTROLE (a executer en base apres 48 h de collecte)
  ----------------------------------------------------------------------

  1. Repartition des sources de widget_interact.
     Si resize represente une part ecrasante (au dela de 70 pour cent) et que
     le device dominant est mobile, il s'agit de bruit de redimensionnement
     (rotation, barre d'adresse) : monter le seuil ou abandonner la source.

     select payload->>'source' as source, device, count(*) as evenements,
            count(distinct session_id) as sessions
     from funnel_events
     where event_type = 'widget_interact'
       and occurred_at > now() - interval '7 days'
     group by 1, 2 order by evenements desc;

  2. Distribution des deltas de hauteur, pour calibrer le seuil de 80 px.

     select device,
            width_bucket((payload->>'delta_px')::numeric, 0, 1000, 10) * 100 as palier_px,
            count(*) as evenements
     from funnel_events
     where event_type = 'widget_interact'
       and payload->>'source' = 'resize'
       and payload ? 'delta_px'
       and occurred_at > now() - interval '7 days'
     group by 1, 2 order by 1, 2;

  3bis. Funnel de fuite a deux etages sur le telephone.
     Beaucoup de revelations sans appel = verification de confiance, le
     visiteur veut s'assurer qu'il y a un humain derriere l'annonce ; ce n'est
     pas une fuite mais un besoin de reassurance a traiter sur la fiche.
     Un taux d'appel eleve apres revelation = fuite reelle hors commission.

     select
       count(distinct session_id) filter (
         where event_type = 'contact_reveal' and payload->>'canal' = 'telephone'
       ) as revelations_tel,
       count(distinct session_id) filter (
         where event_type = 'contact_direct' and payload->>'canal' = 'telephone'
       ) as appels_reels,
       count(distinct session_id) filter (
         where event_type = 'contact_reveal' and payload->>'canal' = 'site'
       ) as revelations_site
     from funnel_events
     where occurred_at > now() - interval '7 days';

  3. Domaines vus en contact_direct, pour recalibrer la liste blanche.

     select payload->>'canal' as canal,
            coalesce(payload->>'domaine', '(sans domaine)') as domaine,
            count(*) as evenements
     from funnel_events
     where event_type = 'contact_direct'
       and occurred_at > now() - interval '7 days'
     group by 1, 2 order by evenements desc;

  4. Evenements non resolus (compteur d'appariement catalogue).

     select date_trunc('day', occurred_at) as jour,
            count(*) filter (where hebergement_id is null) as non_resolus,
            count(*) as total
     from funnel_events
     where occurred_at > now() - interval '7 days'
     group by 1 order by 1;

  5. Sessions ayant depasse 250 evenements sur 7 jours.
     Un compteur non nul indique un parcours anormal ou un abus ; il justifie
     de ne pas remonter le plafond sans diagnostic.

     select count(distinct session_id) as sessions_saturees
     from (
       select session_id from funnel_events
       where occurred_at > now() - interval '7 days'
       group by session_id having count(*) > 250
     ) s;
*/
